'use client'

import { IMAGE_DIR } from '@/shared/constants/linksApi'

export function ProductCardImage({ image }) {
    //Замена пути изображения, если не пришла фотография
    const imageOnError = (event) => {
        event.currentTarget.src = '/bg/stub-pictures-product.png'
    }

    return (
        <img
            src={`${IMAGE_DIR}${image}`}
            alt={'item'}
            onError={imageOnError}
            // loading={'lazy'}
        />
    )
}
